import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const ServiceReminders = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Servis Hatırlatmaları
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Servis hatırlatmaları burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default ServiceReminders;
